export default "__VITE_ASSET__7haGRlwED4JkyOuHIL$T3w__";